module.exports = __webpack_public_path__ + "img/prize-start.5fedc71f.png";